module.exports = __webpack_public_path__ + "static/media/shield.78ac70dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/shield.png
// module id = 960
// module chunks = 0